'use client';
import { useEffect } from 'react';

// Function to map query params to a specific page name
const getPageNameFromUrl = (pathname: string, searchParams: string): string => {
  if (pathname === '/contact') {
    const params = new URLSearchParams(searchParams);
    const topic = params.get('topic');

    if (topic === 'EmployeeBenefitsAndPrograms') {
      return 'Employee benefits & programs';
    }
    if (topic === 'WellnessAndCoaching') {
      return 'Wellness & Coaching';
    }
    if (topic === 'AthletePerformance') {
      return 'Athlete Performance';
    }

    return 'Contact Us';
  }

  // Return the standard name for all other pages
  return pathname;
};

const firePageEvent = (
  pageName: string,
  properties: object,
  attempt: number = 1
) => {
  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.page(pageName, properties);
  } else if (attempt < 10) {
    setTimeout(() => firePageEvent(pageName, properties, attempt + 1), 1000);
  } else if (attempt === 10) {
    console.debug(
      `[Analytics] Segment not available (consent may not be given). Skipping: ${pageName}`
    );
  }
};

export const useAnalyticsPage = (
  defaultPageName: string,
  properties: object = {}
) => {
  const propertiesString = JSON.stringify(properties);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // 1. Get dynamic page name based on URL search parameters
    const dynamicName = getPageNameFromUrl(
      window.location.pathname,
      window.location.search
    );

    // 2. Use the dynamic name if available, otherwise fall back to the default
    const finalPageName =
      dynamicName !== window.location.pathname ? dynamicName : defaultPageName;

    // 3. Trigger the event
    firePageEvent(finalPageName, properties);
  }, [defaultPageName, properties, propertiesString]);
};
